import { useNavigate } from 'react-router-dom';
// import { reviewSummaryBars, reviewSummaryQuote, reviewCheckTips } from '../../../../mocks/reviewDetail';
import { reviewPros, reviewNotes } from '@/mocks/reviewDetail';
export function ReviewSummary1() {
  const navigate = useNavigate();

  return (
    <div id="reviews" className="pt-8">
      <h2 className="text-lg font-bold text-[#121B35]">다이렉트 후기 요약</h2>
      <p className="text-[12px] text-[#536079] mt-1">
        66개의 실제 후기를 분석한 결과입니다.
      </p>

      
      {/* <div className="bg-white rounded-2xl p-4 lg:p-5 mt-3 lg:mt-0">
        <div className="space-y-3">
          {reviewSummaryBars.map((bar, i) => (
            <div key={i}>
              <div className="flex items-center justify-between text-[12px] mb-1">
                <span className="text-[#121B35]">{bar.label}</span>
                <span className="text-[#536079] tabular-nums">{bar.count}</span>
              </div>
              <div className="h-2 bg-[#F7F2EA] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#B9965B] rounded-full transition-all"
                  style={{ width: `${(bar.count / max) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="lg:grid lg:grid-cols-1 lg:gap-4 mt-4 mb-4">
        <div className="bg-white rounded-2xl p-4 lg:p-5 flex flex-col justify-center">
          <p className="font-['MaruBuri'] text-[15px] lg:text-[17px] leading-[1.9] tracking-[-0.02em] text-[#121B35]" style={{fontWeight: 600, color: 'black'}}>
            "{reviewSummaryQuote}"
          </p>
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-2 lg:gap-4 mb-4">
        <div className="bg-white rounded-2xl p-4 lg:p-5 border border-[#E8E2DA]">
          <h3 className="text-[13px] font-semibold text-[#121B35] mb-3">좋았던 점</h3>
          <div className="space-y-3">
            {reviewPositiveBars?.map((bar) => (
              <div key={bar.label}>
                <div className="flex items-center justify-between text-[12px] mb-1">
                  <span className="text-[#121B35]">{bar.label}</span>
                  <span className="text-[#536079] tabular-nums">{bar.count}</span>
                </div>
                <div className="h-2 bg-[#F7F2EA] rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#B9965B] rounded-full transition-all"
                    style={{ width: `${(bar.count / positiveMax) * 100}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl p-4 lg:p-5 border border-[#E8E2DA] mt-3 lg:mt-0">
          <h3 className="text-[13px] font-semibold text-[#121B35] mb-3">아쉬운 점</h3>
          <div className="space-y-3">
            {reviewCautionBars?.map((bar) => (
              <div key={bar.label}>
                <div className="flex items-center justify-between text-[12px] mb-1">
                  <span className="text-[#121B35]">{bar.label}</span>
                  <span className="text-[#536079] tabular-nums">{bar.count}</span>
                </div>
                <div className="h-2 bg-[#F7F2EA] rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#536079] rounded-full transition-all opacity-70"
                    style={{ width: `${(bar.count / cautionMax) * 100}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>      
      <div className="bg-white rounded-2xl p-4 mt-3 border border-[#E8E2DA]" style={{display: 'none'}}>
        <h3 className="text-[12px] font-semibold text-[#121B35] mb-2">확인하면 좋은 점</h3>
        <div className="space-y-2">
          {reviewCheckTips?.map((item, i) => (
            <div key={i} className="flex gap-2 text-[12px] text-[#536079] leading-[1.6]">
              <span className="text-[#B9965B] shrink-0">·</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="lg:flex lg:justify-end">
        <button
          className="w-full lg:w-auto lg:px-10 mt-4 border border-[#121B35] text-[#121B35] rounded-lg py-3 text-[13px] font-medium whitespace-nowrap"
          onClick={() => navigate('reviews')}
        >
          후기 자세히 보기 →
        </button>
      </div>
    </div>
  );
}


interface InsightItem {
  title: string;
  description: string;
}

interface ReviewSummaryProps {
  data: {
    totalReviewCount: number;
    quote: string;
    pros: InsightItem[];
    notes: InsightItem[];
  },
  hideDescription: boolean;
}

export default function ReviewSummary({ data, hideDescription = false }: ReviewSummaryProps) {
  const navigate = useNavigate();

  return (
    <div id="reviews" className="pt-8">
      {/* ── Header ── */}
      <h2 className="text-lg md:text-xl font-bold text-[#121B35]">다이렉트 후기 요약</h2>
      <p className="text-xs md:text-sm text-[#536079] mt-1">
        {data.totalReviewCount}개의 실제 후기를 분석한 결과입니다.
      </p>

      {/* ── AI Quote ── */}
      <div className="mt-4">
        <div className="bg-white rounded-2xl p-4 md:p-5 lg:p-6">
          <p className="text-sm md:text-base text-[#121B35] leading-relaxed font-['MaruBuri'] tracking-[-0.02em]" style={{fontWeight: 600, lineHeight: 1.9}}>
            "{data.quote}"
          </p>
        </div>
      </div>

      {/* ── Pros & Notes ── */}
      <div className="mt-4 lg:grid lg:grid-cols-2 lg:gap-4">
        {/* 좋았던 점 */}
        <div className="bg-white rounded-2xl p-4 md:p-5">
          <h3 className="text-sm md:text-base font-semibold text-[#121B35] mb-3">
            좋았던 점
          </h3>
          <div className="space-y-4">
            {data.pros.map((item, i) => (
              <div key={i} className="flex gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#B9965B] shrink-0 mt-2" />
                <div>
                  <p className="text-sm md:text-base text-[#121B35] font-medium leading-relaxed">
                    {item.title}
                  </p>
                  {hideDescription ? null : (
                    <p className="text-xs md:text-sm text-[#536079] mt-1 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 방문 전 살펴볼 부분 */}
        <div className="bg-white rounded-2xl p-4 md:p-5 mt-3 lg:mt-0">
          <h3 className="text-sm md:text-base font-semibold text-[#121B35] mb-3">
            아쉬운 점
          </h3>
          <div className="space-y-4">
            {data.notes?.map((item, i) => (
              <div key={i} className="flex gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#B9965B] shrink-0 mt-2" />
                <div>
                  <p className="text-sm md:text-base text-[#121B35] font-medium leading-relaxed">
                    {item.title}
                  </p>
                  {hideDescription ? null : (
                    <p className="text-xs md:text-sm text-[#536079] mt-1 leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="lg:flex lg:justify-end">
        <button
          className="w-full lg:w-auto lg:px-10 mt-4 border border-[#121B35] text-[#121B35] rounded-lg py-3 text-sm md:text-base font-medium whitespace-nowrap hover:bg-[#121B35] hover:text-white transition-colors"
          onClick={() => navigate('reviews')}
        >
          후기 자세히 보기 →
        </button>
      </div>
    </div>
  );
}